import stringsToSymbols from "@/util/strings-to-symbols.mjs";

export const QUEUE_SYMBOLS = stringsToSymbols([
  "rankedSoloDuo",
  "rankedFlex",
  "clash",
  "clashAram",
  "clashUrf",
  "normalDraft",
  "normalBlind",
  "aram",
  "aramMayhem",
  "arena",
  "urf",
  "oneForAll",
  "ultimateSpellbook",
  "nexusBlitz",
  "swarm",
  "brawl",
  "doomBots",
  "trialsOfDoom",
  "swiftplay",
  "custom",
  "coopVsAiIntro",
  "coopVsAiBeginner",
  "coopVsAiIntermediate",
]);
